import { React, useState, useRef } from "react";
import { CSVLink } from "react-csv";
import Request from "../../utils/Request";
import RequestV2 from "../../api/RequestV2";
import { ButtonOutline } from "../styledConstants";
import IconDownload from "../../assets/images/IconDownload";
import { extractExportRows } from "./exportUtils";

const CsvDown = ({ digit = 0, headers, url, params, type = "", title = "DOWNLOAD CSV.", contentType, reportName = "Report.csv", method = "post", useV2 = false }) => {
  const [data, setData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const csvLinkRef = useRef(null);

  const downloadReport = () => {
    if (isDisabled) return;
    setIsDisabled(true);
    getUserList();
  };

  const getUserList = () => {
    const successHandler = (res) => {
     const extracted = extractExportRows(res, { method, useV2 });

      const rows =
        extracted?.[0]?.metaInfo?.data ||
        extracted ||
        res?.metaInfo?.data ||
        [];
  
    if (rows?.length) {
  
     const rowsWithAppAccess = rows.map((item) => ({
    ...item,
    ...(headers?.some(h => h.key === "appAccess") && {
      appAccess: item?.status?.toUpperCase() === "ACTIVE" ? "YES" : "NO"
    }),
      ...(headers?.some(h => h.key === "agentStatus") && {
    agentStatus: item?.isAgentActive ? "ACTIVE" : "INACTIVE"
  })

    }));

    const finalData =
      digit == 1
        ? rowsWithAppAccess.map((v) => ({
            ...v,
            transactionId: " txn_ " + (v.transactionId ?? "")
          }))
        : rowsWithAppAccess;

    setData(finalData);

    setTimeout(() => csvLinkRef.current?.link?.click(), 0);
    }

    setIsDisabled(false);
   };

    const errorHandler = () => {
      // On failure, also re-enable so user can retry quickly.
      setIsDisabled(false);
    };
    const RequestClass = useV2 ? RequestV2 : Request;
    const api = new RequestClass("", successHandler, errorHandler);
    if (method === "post") {
      api.post(url, params);
    } else {
      api.get(url);
    }
  };

  return (
    <>
      <CSVLink className="flex" data={data} headers={headers} filename={reportName} ref={csvLinkRef}>
        {" "}
      </CSVLink>
      {url ? (
        <ButtonOutline
          as="span"
          className="flex flex-center"
          primary
          rg
          onClick={downloadReport}
          disabled={isDisabled} // disable the button for 15 seconds after click
          style={{ cursor: isDisabled ? "not-allowed" : "pointer", opacity: isDisabled ? 0.6 : 1 }}
        >
          <IconDownload className="mr8" /> {isDisabled ? "Please wait..." : title}
        </ButtonOutline>
      ) : (
        <ButtonOutline as="span" className="flex flex-center" disabled lg>
          <IconDownload className="mr8" /> {title}
        </ButtonOutline>
      )}
    </>
  );
};

export default CsvDown;
